export default "__VITE_ASSET__DQf5Vt5i__"